import { Label } from '@britishcouncil/react-admin';
import { SemanticCOLORS } from 'semantic-ui-react';
import { ExaminerTrainingStatus } from 'api';

type StatusBadgeProps = {
  status?: ExaminerTrainingStatus;
};

const getLabelOptions = (
  status?: ExaminerTrainingStatus
): { statusText: string; labelColor: SemanticCOLORS } => {
  switch (status) {
    case ExaminerTrainingStatus.Scheduled:
      return {
        statusText: 'Scheduled',
        labelColor: 'yellow',
      };
    case ExaminerTrainingStatus.Completed:
      return {
        statusText: 'Completed',
        labelColor: 'green',
      };
    default:
      return {
        statusText: 'Unknown',
        labelColor: 'grey',
      };
  }
};

export const TrainingAndStandardisationStatusBagde = ({ status }: StatusBadgeProps) => {
  const statusLabelOptions = getLabelOptions(status);

  return <Label color={statusLabelOptions.labelColor}>{statusLabelOptions.statusText}</Label>;
};
